import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/buttons';
import { mergeClasses } from '@/utils/style';
import React from 'react';
import IconArrow from '@/assets/icons/heroIcons/Arrow-right.svg';
import { ContentContainer } from '@/components/layout';
import { addPrefixToDataParams } from '@/utils/string';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { SectionHeadline } from '@/components/SectionHeadline';
import { BlogPost } from '@/api/wordpress/blogPosts';
import Image from 'next/image';
const Post = t0 => {
  const $ = _c(48);
  const {
    date,
    image,
    intro,
    label,
    title,
    to,
    variant
  } = t0;
  const isPrimary = variant === "primary";
  const isSecondary = variant === "secondary";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = addPrefixToDataParams({
      analyticsParam: "homepageBlogGoToPost",
      testId: "homepageBlogGoToPost",
      prefix: "link"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isPrimary && "flex-col pb-4 md:row-span-3 lg:px-6 lg:pt-6 lg:pb-8";
  const t3 = isSecondary && "lg:py-4 lg:pr-8 lg:pl-4";
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = mergeClasses("relative flex items-center rounded-2xl bg-blue-800 p-3 transition hover:bg-blue-700 lg:rounded-4xl", t2, t3);
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isPrimary && "top-6 right-6 lg:top-10 lg:right-auto lg:left-9";
  const t6 = isSecondary && "-top-3 right-8 lg:right-14";
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = mergeClasses("absolute rounded-lg bg-green-600 px-3 py-1 text-xs font-semibold", t5, t6);
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== label || $[8] !== t7) {
    t8 = <div className={t7}>{label}</div>;
    $[7] = label;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = isPrimary && "mb-4 h-45 w-full lg:mb-8 lg:h-84";
  const t10 = isSecondary && "h-[90px] flex-[0_0_90px] lg:h-[152px] lg:flex-[0_0_152px]";
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = mergeClasses("relative overflow-hidden rounded-lg bg-cover bg-center bg-no-repeat lg:rounded-[20px]", t9, t10);
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== image.alt || $[14] !== image.src) {
    t12 = <Image src={image.src} alt={image.alt} objectFit="cover" layout="fill" />;
    $[13] = image.alt;
    $[14] = image.src;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = isSecondary && "ml-4";
  let t15;
  if ($[19] !== t14) {
    t15 = mergeClasses(t14);
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  const t16 = isPrimary && "mb-2";
  let t17;
  if ($[21] !== t16) {
    t17 = mergeClasses("mb-1.5 text-xs opacity-50 lg:mb-3", t16);
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== date || $[24] !== t17) {
    t18 = <div className={t17}>{date}</div>;
    $[23] = date;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  const t19 = isPrimary && "text-sm";
  let t20;
  if ($[26] !== t19) {
    t20 = mergeClasses("text-sm font-semibold lg:text-base", t19);
    $[26] = t19;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== t20 || $[29] !== title) {
    t21 = <h3 className={t20}>{title}</h3>;
    $[28] = t20;
    $[29] = title;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] !== intro || $[32] !== isSecondary) {
    t22 = intro && <p className={mergeClasses("text-light-gray-100 mt-1 line-clamp-2 text-xs lg:text-sm xl:mt-2", isSecondary && "hidden md:line-clamp-2")}>{intro}</p>;
    $[31] = intro;
    $[32] = isSecondary;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== t15 || $[35] !== t18 || $[36] !== t21 || $[37] !== t22) {
    t23 = <div className={t15}>{t18}{t21}{t22}</div>;
    $[34] = t15;
    $[35] = t18;
    $[36] = t21;
    $[37] = t22;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== isPrimary) {
    t24 = isPrimary && <div className="absolute right-0 bottom-0 hidden h-18 w-18 items-center justify-center rounded-tl-4xl rounded-br-4xl bg-blue-700 text-white lg:flex"><IconArrow /></div>;
    $[39] = isPrimary;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] !== t13 || $[42] !== t23 || $[43] !== t24 || $[44] !== t4 || $[45] !== t8 || $[46] !== to) {
    t25 = <Link {...t1} href={to} className={t4} target="_blank">{t8}{t13}{t23}{t24}</Link>;
    $[41] = t13;
    $[42] = t23;
    $[43] = t24;
    $[44] = t4;
    $[45] = t8;
    $[46] = to;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  return t25;
};
export function Blog(t0) {
  const $ = _c(17);
  const {
    posts
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["homepage"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("homepage:blogSectionTitle");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <SectionHeadline className="mb-10 lg:mb-16" variant="inverted" anchorKey="homepage.blogSectionTitle">{t2}</SectionHeadline>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== posts) {
    t4 = posts.map(_temp);
    $[5] = posts;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="grid gap-6 lg:grid-flow-col lg:grid-cols-[40%_57%] lg:grid-rows-3 lg:gap-8">{t4}</div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("homepage:showAllBlogPosts");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Button align="center" to="https://skippay.cz/blog" variant="primary" size="lg" testId="homepageBlogPostsShowAll" analyticsParam="homepageBlogPostsShowAll" className="mt-12 lg:mt-16">{t6}</Button>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t5 || $[15] !== t7) {
    t8 = <div className="4xl:px-16 2xl:px-7"><div className="w-full rounded-3xl bg-blue-900 px-4 pt-14 pb-14 text-white md:px-8 md:pb-16 lg:rounded-[2.5rem] lg:px-12 lg:py-20 2xl:m-auto"><ContentContainer>{t3}{t5}{t7}</ContentContainer></div></div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp(post, index) {
  return <Post {...post} key={post.id} variant={index === 0 ? "primary" : "secondary"} />;
}